;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import type { ButtonProps } from "@mui/material/Button"

import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../lib/constants"

const CustomButton = styled(Button)(({ theme }) => ({
  boxShadow: "none",
  width: "188px",
  height: "52px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textAlign: "center",
  letterSpacing: "0.03em",
  color: UI_STYLE_BLACK_COLOR_BUTTON,
  textTransform: "unset",

  // textShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
  border: `1px solid ${UI_STYLE_PRIMARY_BLUE_BLACK}`,
  borderRadius: "100px",
  "@media only screen and (min-width: 600px)": {
    fontSize: "18px",
    width: "213px",
  },
  "&:hover": {
    backgroundColor: "rgb(9, 44, 60, 0.08)",
    borderColor: UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  },
}))

type SecondaryButtonProps = {
  text: string
  href?: ButtonProps["href"]
  onClick?: ButtonProps["onClick"]
}

function SecondaryButton({ onClick, href, text }: SecondaryButtonProps) {
  return (
    <CustomButton variant="outlined" href={href} onClick={onClick}>
      {text}
    </CustomButton>
  )
}

export default SecondaryButton
